import React from "react";

type ConfirmPopupProps = {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isOpen?: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const ConfirmPopup: React.FC<ConfirmPopupProps> = ({
  title = "Confirm",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isOpen,
  loading,
  onCancel,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-lg w-96 p-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">{title}</h3>
        <p className="text-sm text-gray-600 mb-4">{message}</p>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-60"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="px-4 py-2 rounded bg-primary text-white hover:bg-primary-dark disabled:opacity-60"
          >
            {loading ? "Working..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
